import type { FaireProductEntity } from "../../entity_types/product";

export const p_v8yqh3avzu: FaireProductEntity = {
  token: "p_v8yqh3avzu",
  type: "product",
  name: "LM-SW-1007 Navy/Light Blue Puff",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/4c3f59142dd3e1063260a0f5d342f66404481e689667103db5f069b563c5cc50.jpeg",
  galleryImageUrls: [],
  priceDollars: 24.5,
  description: "This women's graphic sweatshirt from Girlie Girl Originals in Navy/Light Blue features a puff graphic detail and combines casual comfort with an eye-catching design. Thoughtfully crafted for reliable wear, it offers a silhouette suitable for layering while showcasing the Girlie Girl Originals southern-inspired brand style.",
  tags: [],
  msrpDollars: 49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:37.236Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
